import { useEffect, useState } from "react"
import type { SelectOptionType, SuccessFetch } from "../../../../../../../../types"
import { useApi } from "../../../../../../../../utils"

export function useSalaryType() {
  const api = useApi()
  const [data, setData] = useState<SelectOptionType[]>([])
  const [isLoading, setLoading] = useState(false)

  const refetch = () => {
    setLoading(true)

    api.get("/salarytype/")
    .then((res: SuccessFetch<{
      payload: {
        salary_type_id: number
        salary_type_name: string
      }[]
    }>) => { setData(res.data.payload.map(item => { return { label: item.salary_type_name, value: item.salary_type_id.toString() }}))})
    .catch(() => setData([]))
    .finally(() => setLoading(false))
  }

  useEffect(() => {
    setLoading(true)

    api.get("/salarytype/")
    .then((res: SuccessFetch<{
      payload: {
        salary_type_id: number
        salary_type_name: string
      }[]
    }>) => { setData(res.data.payload.map(item => { return { label: item.salary_type_name, value: item.salary_type_id.toString() }}))})
    .catch(() => setData([]))
    .finally(() => setLoading(false))
    // eslint-disable-next-line
  }, [])

  return { data, isLoading, refetch }
}